import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.OrderPage.components.TaskPage.components.OpenQualityCheckDialog.title',
    defaultMessage: 'Complete Q/C',
  },
  cancel: {
    id: 'containers.OrderPage.components.TaskPage.components.OpenQualityCheckDialog.cancel',
    defaultMessage: 'Cancel',
  },
  loading: {
    id: 'containers.OrderPage.components.TaskPage.components.OpenQualityCheckDialog.loading',
    defaultMessage: 'Submitting..',
  },
  submit: {
    id: 'containers.OrderPage.components.TaskPage.components.OpenQualityCheckDialog.submit',
    defaultMessage: 'Approve',
  },
  sideEffects: {
    id: 'containers.OrderPage.components.TaskPage.components.OpenQualityCheckDialog.sideEffects',
    defaultMessage: `
      <li>@TODO</li>
      <li>Production notes</li>
    `
  },
  reject: {
    id: 'containers.OrderPage.components.TaskPage.components.OpenQualityCheckDialog.reject',
    defaultMessage: 'Reject'
  },
  commentLabel: {
    id: 'containers.OrderPage.components.TaskPage.components.OpenQualityCheckDialog.comment.label',
    defaultMessage: 'Comment'
  },
  commentPlaceholder: {
    id: 'containers.OrderPage.components.TaskPage.components.OpenQualityCheckDialog.comment.placeholder',
    defaultMessage: 'Describe the identified issue for the records, here.'
  },
})
